import Image from "next/image";
import Link from "next/link";

const ProfessionalsTrust = ({ professionalsTrustData }) => {
  return (
    <section className="bg-[#F0F7FF] py-[100px] sm:py-20">
      <div className="container xm:px-2 px-3">
        <h2 className="text-heading5 sm:text-3xl font-medium text-center text-[#072F5F]">
          {professionalsTrustData.title}
        </h2>
        <p className="text-baseBlack text-lg text-center mt-xsp">
          {professionalsTrustData.subtitle}
        </p>

        <div className="flex sm:flex-col md:flex-row justify-center gap-10 mt-10">
          {professionalsTrustData.features.map((feature) => (
            <div
              key={feature.id}
              className="flex-1 text-center max-w-sm mx-auto"
            >
              <div className="flex justify-center mb-4">
                <Image
                  src={feature.icon}
                  alt={feature.title}
                  width={120}
                  height={120}
                  quality={true}
                />
              </div>

              <h3 className="font-semibold text-[22px] leading-8 text-baseBlack">
                {feature.title}
              </h3>
              <p className="text-baseBlack mt-1 text-base leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 sm:mt-6 text-center">
          <Link
            href={professionalsTrustData.cta.link}
            className="bg-gradient-to-r from-[#022B5C] to-[#0363C4] text-white px-4 py-2 rounded-full shadow-md transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C] text-base font-normal"
          >
            {professionalsTrustData.cta.text}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProfessionalsTrust;
